import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "className", "hideBgWhite", "iconContainerClassName"];
import clsx from 'clsx';
import { LoadingIcon } from '../Icons/LoadingIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LoadingMask = function LoadingMask(_ref) {
  var label = _ref.label,
      className = _ref.className,
      hideBgWhite = _ref.hideBgWhite,
      iconContainerClassName = _ref.iconContainerClassName,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx("div", {
    className: clsx("inset-0 z-40 backdrop-blur-sm", {
      'bg-white/90': !hideBgWhite,
      absolute: !className
    }, className),
    children: /*#__PURE__*/_jsxs("div", {
      className: clsx('relative -translate-y-1/2', !!iconContainerClassName ? iconContainerClassName : 'top-1/2'),
      children: [/*#__PURE__*/_jsx(LoadingIcon, {
        className: "ml-auto mr-auto"
      }), label && /*#__PURE__*/_jsx("div", {
        className: "mt-8 text-center",
        children: label
      })]
    })
  });
};